import React, { 
  Component 
} from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';

import { zfImagePropType } from 'zoomforth_codesbane_viewer/lib/prop_types.js';
import { getValidDomImgAttributes } from 'zoomforth_zfutils/react_helpers.js';


// Needs to be a stateful component to allow passing of refs:
// https://stackoverflow.com/questions/35952607/what-does-stateless-function-components-cannot-be-given-refs-mean
class Image extends Component {
  render() {
    if (!this.props.zfImage) {
      const alt = this.props.altText;
      // displays the legacy image tag
      return (
        <img 
          {...getValidDomImgAttributes({ ...this.props, alt })}
          ref={this.props.refFunc}
        />
      );
    }
 
    const {
      zfImage,
      altText,
      className,
      animationClasses,
    } = this.props;
    const refFunc = this.props.refFunc || noop;

    var style = this.props.style;
    if (zfImage.cropData) {
      if (zfImage.cropData.borderRadius) {
        style = { ...style, borderRadius: `${zfImage.cropData.borderRadius}%` };
      }
    }

    return <img {...{
      ...getValidDomImgAttributes(this.props),
      ref: (ref) => zfImage.cropData || refFunc(ref), // Only run this if the image has not been cropped, since this ref is used to resize the image which actually distorts the image slightly for cropped images that are already sized properly.
      className: classNames(className, animationClasses, zfImage.cropData ? 'is-cropped' : 'is-not-cropped'),
      src: zfImage.src,
      style,
      alt: altText
    }} />;
  }
}

Image.propTypes = {
  zfImage: zfImagePropType,
  src: PropTypes.string, // ?
  altText: PropTypes.string,
  className: PropTypes.string,
  animationClasses: PropTypes.string,
  style: PropTypes.object
};

export default Image;
